import service from "./service"

const downloadConsent = async (data) => {
    return service(data)
}

export default downloadConsent
